import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { Customer, CustomerState } from '../types/customer';

// Guarda a diferença (e não a hora) para a janela das campanhas seguir o
// relógio do servidor mesmo com a página aberta por horas.
const calcServerTimeOffset = (customer: Customer | null): number | null => {
  const serverMs = customer?.serverDate ? Date.parse(customer.serverDate) : NaN;
  return Number.isNaN(serverMs) ? null : serverMs - Date.now();
};

export const useCustomerStore = create<CustomerState>()(
  devtools(
    set => ({
      customer: null,
      featureToggles: null,
      serverTimeOffsetMs: null,

      setCustomer: customer =>
        set(
          { customer, serverTimeOffsetMs: calcServerTimeOffset(customer) },
          false,
          'setCustomer',
        ),
      setFeatureToggles: featureToggles =>
        set({ featureToggles }, false, 'setFeatureToggles'),
      clearCustomer: () =>
        set(
          { customer: null, featureToggles: null, serverTimeOffsetMs: null },
          false,
          'clearCustomer',
        ),
    }),
    { name: 'CustomerStore' },
  ),
);
